<template>
    <div class="modal-dialog modal-xl" v-if="showModal">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Editar Empleado</h4>
                <button ref="closeEmployeeModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="mb-3"><span style="font-size: 14px; font-weight: bold;">Información del Empleado</span></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="mb-3">
                                <label>Nombre</label>
                                <input class="form-control" type="text" v-model="form.name" v-bind:class="formSubmitted ? errors.name ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.name = form.name.toUpperCase()">
                                <div class="invalid-feedback" v-if="errors.name">{{ errors.name }}</div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="mb-3">
                                <label>No. Empleado</label>
                                <input class="form-control" type="text" v-model="form.employee_number" v-bind:class="formSubmitted ? errors.employee_number ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.employee_number = form.employee_number.toUpperCase()">
                                <div class="invalid-feedback" v-if="errors.employee_number">{{ errors.employee_number }}</div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="mb-3">
                                <label>Residencia Fiscal (C.P.)</label>
                                <input class="form-control" type="text" v-model="form.zipcode" v-bind:class="formSubmitted ? errors.zipcode ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.zipcode = form.zipcode.toUpperCase()">
                                <div class="invalid-feedback" v-if="errors.zipcode">{{ errors.zipcode }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="mb-3">
                                <label>RFC</label>
                                <input class="form-control" type="text" v-model="form.rfc" v-bind:class="formSubmitted ? errors.rfc ? 'is-invalid' : 'is-valid' : ''" placeholder="" required="" @input="form.rfc = form.rfc.toUpperCase()">
                                <div class="invalid-feedback" v-if="errors.rfc">{{ errors.rfc }}</div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="mb-3">
                                <label>CURP</label>
                                <input class="form-control" type="text" v-model="form.curp" v-bind:class="formSubmitted ? errors.curp ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.curp = form.curp.toUpperCase()">
                                <div class="invalid-feedback" v-if="errors.curp">{{ errors.curp }}</div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="mb-3">
                                <label>NSS</label>
                                <input class="form-control" type="text" v-model="form.nss" v-bind:class="formSubmitted ? errors.nss ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.nss = form.nss.toUpperCase()">
                                <div class="invalid-feedback" v-if="errors.nss">{{ errors.nss }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="mb-3"><span style="font-size: 14px; font-weight: bold;">Información de Contratación</span></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="mb-3">
                                <label>Patrón</label>
                                <select class="form-select" v-model="form.employer_id">
                                    <option v-for="(employer, index) in employers" :key="index" :value="employer.id">{{ employer.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="mb-3">
                                <label>Jefe Inmediato</label>
                                <select class="form-select" v-model="form.employee_boss_id">
                                    <option v-for="(boss, index) in bosses" :key="index" :value="boss.id">{{ boss.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="mb-3">
                                <label>Puesto</label>
                                <select class="form-select" v-model="form.employee_position_id">
                                    <option v-for="(job_position, index) in job_positions" :key="index" :value="job_position.id">{{ job_position.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="mb-3">
                                <label>Fecha de Ingreso</label>
                                <Datepicker class="datepicker-here form-control digits dp2" v-model="form.initial_date" :enable-time-picker="false" :locale="'es-MX'" :format-locale="es" format="dd/MM/yyyy"></Datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="mb-3">
                                <label>Salario Diario</label>
                                <input class="form-control" type="text" v-model="form.daily_salary" placeholder="" @input="calculate()">
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="mb-3">
                                <label>Salario Diario Integrado</label>
                                <input class="form-control" type="text" v-model="form.integral_daily_salary" placeholder="" disabled>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="mb-3">
                                <label>Sueldo Neto (Contrato)</label>
                                <input class="form-control" type="text" v-model="form.final_wage" placeholder="">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="mb-3"><span style="font-size: 14px; font-weight: bold;">Datos Bancarios</span></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="mb-3">
                                <label>Banco</label>
                                <select class="form-select" v-model="form.bank">
                                    <option v-for="(bank, index) in banks" :key="index" :value="bank.name">{{ bank.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="mb-3">
                                <label>Cuenta / Clabe Interbancaria</label>
                                <input class="form-control" type="text" v-model="form.clabe" placeholder="">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="updateEmployeeValidation">Guardar Cambios</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employees'

import validations from "@/mixins/validations/employeeValidations";
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { es } from 'date-fns/locale'

import formatDate from '@/filters/dateFormatter'

export default {
    name: 'employee_detailed_modal',
    mixins: [validations, modalCleanupMixin],
    components: {
        Datepicker
    },
    data(){
        return{
            id: 0,
            showModal: true,
            employee: null,
            job_positions: [],
            employers: [],
            bosses: [],
            banks: [],
            collaborators: []
        }
    },
    beforeMount: async function() {
        let response2 = await ws.getPositions();

        if(response2.type == "success"){
            this.job_positions = response2.data;
        }

        let response3 = await ws.getEmployers(); 

        if(response3.type == "success"){
            this.employers = response3.data;
        }

        let response4 = await ws.getBosses(); 

        if(response4.type == "success"){
            this.bosses = response4.data;
        }

        let response5 = await ws.getCollaborators(); 

        if(response5.type == "success"){
            this.collaborators = response5.data;
        }

        let response6 = await ws.getBanks(); 

        if(response6.type == "success"){
            this.banks = response6.data;
        }
    },
    methods: {
        loadEmployee(employee){
            this.employee = employee;

            this.setForm(this.employee);
        },
        async updateEmployee(form) {
            form.initial_date = form.initial_date.toLocaleDateString('es-MX');
            form.final_date = form.final_date.toLocaleDateString('es-MX');

            let response = await ws.updateEmployee(form);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.$emit("refresh", response.data );

                this.closeModal();
            }
            else{
                this.$toast.error(response.message);
            }
        },
        async calculate(){
            this.form.integral_daily_salary = (this.form.daily_salary * this.form.integration_factor).toFixed(2);
        },
        closeModal(){
            this.$refs.closeEmployeeModal.click();
        }
    },
}
</script>
<style scoped>
    .container-fluid {
        padding-top: 20px;
    }

    .title{
        font-size: 28px;
    }

    .datepicker-here{
        padding: 0.25rem 0.75rem;
    }

    .rest_days{
        margin-left: 10px;
        float: right;
    }

    .rest_days td{
        padding-right: 8px;
        text-align: center;
    }

    .infonavit td{
        text-align: center;
    }
</style>